/**
 * Parallax effect for call-to-action section variant 2 background images
 * Moves background image at a slower speed than scroll to create depth effect
 */

//console.log("[CTA Parallax] Script loaded");

class CallToActionParallax {
  constructor(section) {
    this.section = section;
    this.image = section.querySelector(".call-to-action__image");

    if (!this.image) {
      //console.warn("[CTA Parallax] No image found, skipping");
      return;
    }

    // Check if user prefers reduced motion
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      //console.log(
      //  "[CTA Parallax] Reduced motion preference detected, skipping"
      //);
      return;
    }

    //console.log("[CTA Parallax] Initializing with speed: -0.5");

    // Parallax speed (negative value moves up as you scroll down)
    this.speed = 1.2;
    this.maxOffset = 150;

    // Throttle scroll handler to avoid too many updates
    let ticking = false;
    this.scrollHandler = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", this.scrollHandler, { passive: true });
    window.addEventListener("resize", () => this.updateParallax(), {
      passive: true,
    });

    // Initial update
    this.updateParallax();
  }

  updateParallax() {
    if (!this.image) return;

    const rect = this.section.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const sectionTop = rect.top;
    const sectionHeight = rect.height;
    const sectionBottom = rect.bottom;

    // Calculate progress: 0 when section enters viewport, 1 when it exits
    let progress = 0;

    if (sectionBottom > 0 && sectionTop < windowHeight) {
      // Section is visible in viewport
      const totalScrollDistance = sectionHeight + windowHeight;
      const currentScrollDistance = windowHeight - sectionTop;
      progress = currentScrollDistance / totalScrollDistance;
      progress = Math.max(0, Math.min(1, progress));
    } else if (sectionTop >= windowHeight) {
      progress = 0;
    } else if (sectionBottom <= 0) {
      progress = 1;
    }

    // Calculate offset
    const offset = progress * (this.maxOffset || 150) * (this.speed || 1.2);

    // Apply transform
    if (this.image && this.image.style) {
      this.image.style.transform = `translateY(${offset}px) translateZ(0)`;
    }
  }

  destroy() {
    if (this.image) {
      this.image.style.transform = "";
    }
    if (this.scrollHandler) {
      window.removeEventListener("scroll", this.scrollHandler);
    }
  }
}

// Track instances for cleanup
const callToActionParallaxInstances = new WeakMap();

function initParallax() {
  const sections = document.querySelectorAll(".call-to-action--variant-2");
  //console.log("[CTA Parallax] Found", sections.length, "variant-2 section(s)");

  sections.forEach((section) => {
    if (callToActionParallaxInstances.has(section)) {
      //console.log("[CTA Parallax] Section already initialized, skipping");
      return;
    }

    const instance = new CallToActionParallax(section);
    callToActionParallaxInstances.set(section, instance);
  });
}

// Initialize when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initParallax);
} else {
  initParallax();
}

// Handle dynamic section loading (Shopify theme editor)
document.addEventListener("shopify:section:load", (event) => {
  const detail = event.detail || {};
  const sectionElement = detail.section;
  if (sectionElement) {
    const section = sectionElement.querySelector(".call-to-action--variant-2");
    if (section) {
      const existingInstance = callToActionParallaxInstances.get(section);
      if (existingInstance) {
        existingInstance.destroy();
      }
      const instance = new CallToActionParallax(section);
      callToActionParallaxInstances.set(section, instance);
    }
  }
});

document.addEventListener("shopify:section:unload", (event) => {
  const detail = event.detail || {};
  const sectionElement = detail.section;
  if (sectionElement) {
    const section = sectionElement.querySelector(".call-to-action--variant-2");
    if (section) {
      const instance = callToActionParallaxInstances.get(section);
      if (instance) {
        instance.destroy();
        callToActionParallaxInstances.delete(section);
      }
    }
  }
});
